<!-- Formato pantallas grandes -->
<div class="hidden sm:block">
  <div class="container-step flex mt-3 mb-3">
    <ng-container *ngIf="tipoEntrega != 'RETDA'">
      <div
        class="step col text-center"
        [ngClass]="Informe_estado[0] ? 'step-active' : ''"
      >
        <span
          class="number mx-auto number-right"
          [ngClass]="Informe_estado[0] ? 'step-active' : ''"
        >
          <i class="far fa-file-alt"></i>
        </span>
        <span class="subtitle"> Creado </span><br />
        <span
          *ngIf="Informe_estado[0] && Informe_estado[0].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[0].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </div>

      <div
        class="step col text-center"
        [ngClass]="
          Informe_estado[1] || Informe_estado[2] || Informe_estado[3]
            ? 'step-active'
            : ''
        "
      >
        <span
          class="number mx-auto number-right"
          [ngClass]="Informe_estado[1] ? 'step-active' : ''"
          ><i class="fas fa-cubes"></i
        ></span>
        <span class="subtitle"> En Preparación </span><br />
        <span
          *ngIf="Informe_estado[1] && Informe_estado[1].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[1].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            !Informe_estado[1] &&
            Informe_estado[2] &&
            Informe_estado[2].trackingDate
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[2].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            !Informe_estado[1] &&
            !Informe_estado[2] &&
            Informe_estado[3] &&
            Informe_estado[3].trackingDate
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[3].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </div>

      <div
        class="step col text-center"
        [ngClass]="Informe_estado[2] || Informe_estado[3] ? 'step-active' : ''"
      >
        <span
          class="number mx-auto number-right"
          [ngClass]="Informe_estado[2] ? 'step-active' : ''"
          ><i class="fas fa-dolly"></i
        ></span>
        <span class="subtitle"> En reparto a domicilio</span><br />
        <span
          *ngIf="Informe_estado[2] && Informe_estado[2].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[2].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            !Informe_estado[2] &&
            Informe_estado[3] &&
            Informe_estado[3].trackingDate
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[3].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </div>

      <div
        class="step col text-center"
        [ngClass]="Informe_estado[3] ? 'step-active' : ''"
      >
        <span class="number mx-auto">
          <ng-container *ngIf="Informe_estado[3] === undefined"
            ><i class="fas fa-check"></i
          ></ng-container>
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status == 'cancelled'
            "
            ><i class="fas fa-ban"></i
          ></ng-container>
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status != 'cancelled'
            "
          >
            <i class="fas fa-check"></i
          ></ng-container>
        </span>
        <span class="subtitle">
          <ng-container *ngIf="Informe_estado[3] === undefined"
            >RECIBIDO</ng-container
          >
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              (Informe_estado[3].status == 'N/A' ||
                Informe_estado[3].status == 'cancelled')
            "
            >Cancelada</ng-container
          >
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status != 'N/A'
            "
            >{{ Informe_estado[3].satusName }}</ng-container
          >
        </span>
        <br />
        <span
          *ngIf="Informe_estado[3] && Informe_estado[3].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[3].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </div>
    </ng-container>
    <ng-container *ngIf="tipoEntrega == 'RETDA'">
      <div
        class="step col text-center"
        [ngClass]="Informe_estado[0] ? 'step-active' : ''"
      >
        <span
          class="number mx-auto number-right"
          [ngClass]="Informe_estado[0] ? 'step-active' : ''"
        >
          <i class="far fa-file-alt"></i>
        </span>
        <span class="subtitle"> Creado </span><br />
        <span
          *ngIf="Informe_estado[0] && Informe_estado[0].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[0].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </div>

      <div
        class="step col text-center"
        [ngClass]="
          Informe_estado[1] || Informe_estado[2] || Informe_estado[3]
            ? 'step-active'
            : ''
        "
      >
        <span
          class="number mx-auto number-right"
          [ngClass]="Informe_estado[1] ? 'step-active' : ''"
          ><i class="fas fa-cubes"></i
        ></span>
        <span class="subtitle"> En Preparación </span><br />
        <span
          *ngIf="Informe_estado[1] && Informe_estado[1].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[1].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            !Informe_estado[1] &&
            Informe_estado[2] &&
            Informe_estado[2].trackingDate
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[2].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            !Informe_estado[1] &&
            !Informe_estado[2] &&
            Informe_estado[3] &&
            Informe_estado[3].trackingDate
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[3].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </div>

      <div
        class="step col text-center"
        [ngClass]="Informe_estado[2] || Informe_estado[3] ? 'step-active' : ''"
      >
        <span
          class="number mx-auto number-right"
          [ngClass]="estado_envio.nombre !== undefined ? 'step-active' : ''"
          ><i class="fas fa-store"></i
        ></span>
        <span class="subtitle"> Retirar en tienda</span><br />
        <span
          *ngIf="Informe_estado[2] && Informe_estado[2].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[2].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            Informe_estado[3] &&
            Informe_estado[1] &&
            !Informe_estado[2] &&
            Informe_estado[3].trackingDate
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[1].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            !Informe_estado[1] &&
            !Informe_estado[2] &&
            Informe_estado[3] &&
            Informe_estado[3].trackingDate
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[3].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </div>

      <div
        class="step col text-center"
        [ngClass]="Informe_estado[3] ? 'step-active' : ''"
      >
        <span class="number mx-auto">
          <ng-container *ngIf="Informe_estado[3] === undefined"
            ><i class="fas fa-check"></i
          ></ng-container>
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status == 'cancelled'
            "
            ><i class="fas fa-ban"></i
          ></ng-container>
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status != 'cancelled'
            "
          >
            <i class="fas fa-check"></i
          ></ng-container>
        </span>
        <span class="subtitle">
          <ng-container *ngIf="Informe_estado[3] === undefined"
            >RECIBIDO</ng-container
          >
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              (Informe_estado[3].status == 'undefined' ||
                Informe_estado[3].status == 'cancelled')
            "
            >Cancelada</ng-container
          >
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status != 'N/A'
            "
            >{{ Informe_estado[3].statusName }}</ng-container
          >
        </span>
        <br />
        <span
          *ngIf="Informe_estado[3] && Informe_estado[3].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[3].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </div>
    </ng-container>
  </div>
</div>
<!-- End Formato pantallas grandes -->

<!-- Formato mobiles -->
<div class="block lg:hidden">
  <div class="container-step flex mt-3 row">
    <ng-container *ngIf="tipoEntrega != 'RETDA'">
      <div
        class="step col-12 text-center"
        [ngClass]="Informe_estado[0] ? 'step-active' : ''"
      >
        <span
          class="number mx-auto"
          [ngClass]="Informe_estado[0] ? 'step-active' : ''"
        >
          <i class="far fa-file-alt"></i>
        </span>
        <span class="subtitle"> Creado </span> <br />
        <span
          *ngIf="Informe_estado[0] && Informe_estado[0].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[0].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <br />
        <span> <i class="fas fa-long-arrow-alt-down icon-down"></i> </span>
      </div>

      <div
        class="step col-12 text-center"
        [ngClass]="
          Informe_estado[1] || Informe_estado[2] || Informe_estado[3]
            ? 'step-active'
            : ''
        "
      >
        <span
          class="number mx-auto"
          [ngClass]="Informe_estado[1] ? 'step-active' : ''"
          ><i class="fas fa-cubes"></i
        ></span>
        <span class="subtitle"> En Preparación </span> <br />
        <span
          *ngIf="Informe_estado[1] && Informe_estado[1].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[1].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            !Informe_estado[1] &&
            Informe_estado[2] &&
            Informe_estado[2].trackingDate
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[2].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            !Informe_estado[1] &&
            !Informe_estado[2] &&
            Informe_estado[3] &&
            Informe_estado[3].FechaSeguimiento
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[3].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <br /><span>
          <i class="fas fa-long-arrow-alt-down icon-down"></i>
        </span>
      </div>

      <div
        class="step col-12 text-center"
        [ngClass]="Informe_estado[2] || Informe_estado[3] ? 'step-active' : ''"
      >
        <span
          class="number mx-auto"
          [ngClass]="Informe_estado[2] ? 'step-active' : ''"
          ><i class="fas fa-dolly"></i
        ></span>
        <span class="subtitle"> En reparto a domicilio</span> <br />
        <span
          *ngIf="Informe_estado[2] && Informe_estado[2].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[2].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            !Informe_estado[2] &&
            Informe_estado[3] &&
            Informe_estado[3].trackingDate
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[3].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <br /><span>
          <i class="fas fa-long-arrow-alt-down icon-down"></i>
        </span>
      </div>

      <div
        class="step col-12 text-center"
        [ngClass]="Informe_estado[3] ? 'step-active' : ''"
      >
        <span class="number mx-auto">
          <ng-container *ngIf="Informe_estado[3] === undefined"
            ><i class="fas fa-check"></i
          ></ng-container>
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status == 'N/A'
            "
            ><i class="fas fa-ban"></i
          ></ng-container>
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status != 'N/A'
            "
          >
            <i class="fas fa-check"></i
          ></ng-container>
        </span>
        <span class="subtitle">
          <ng-container *ngIf="Informe_estado[3] === undefined"
            >RECIBIDO</ng-container
          >
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status == 'N/A'
            "
            >Cancelada</ng-container
          >
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status != 'N/A'
            "
            >{{ Informe_estado[3].statusName }}</ng-container
          >
        </span>
        <br />
        <span
          *ngIf="Informe_estado[3] && Informe_estado[3].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[3].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </div>
    </ng-container>
    <ng-container *ngIf="tipoEntrega == 'RETDA'">
      <div
        class="step col-12 text-center"
        [ngClass]="Informe_estado[0] ? 'step-active' : ''"
      >
        <span
          class="number mx-auto"
          [ngClass]="Informe_estado[0] ? 'step-active' : ''"
        >
          <i class="far fa-file-alt"></i>
        </span>
        <span class="subtitle"> Creado </span> <br />
        <span
          *ngIf="Informe_estado[0] && Informe_estado[0].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[0].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <br />
        <span> <i class="fas fa-long-arrow-alt-down icon-down"></i> </span>
      </div>

      <div
        class="step col-12 text-center"
        [ngClass]="
          Informe_estado[1] || Informe_estado[2] || Informe_estado[3]
            ? 'step-active'
            : ''
        "
      >
        <span
          class="number mx-auto"
          [ngClass]="Informe_estado[1] ? 'step-active' : ''"
          ><i class="fas fa-cubes"></i
        ></span>
        <span class="subtitle"> En Preparación </span> <br />
        <span
          *ngIf="Informe_estado[1] && Informe_estado[1].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[1].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            !Informe_estado[1] &&
            Informe_estado[2] &&
            Informe_estado[2].trackingDate
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[2].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            !Informe_estado[1] &&
            !Informe_estado[2] &&
            Informe_estado[3] &&
            Informe_estado[3].trackingDate
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[3].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <br />
        <span> <i class="fas fa-long-arrow-alt-down icon-down"></i> </span>
      </div>

      <div
        class="step col-12 text-center"
        [ngClass]="Informe_estado[2] || Informe_estado[3] ? 'step-active' : ''"
      >
        <span
          class="number mx-auto"
          [ngClass]="estado_envio.nombre !== undefined ? 'step-active' : ''"
          ><i class="fas fa-store"></i
        ></span>
        <span class="subtitle"> Retirar en tienda</span> <br />
        <span
          *ngIf="Informe_estado[2] && Informe_estado[2].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[2].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            Informe_estado[3] &&
            Informe_estado[1] &&
            !Informe_estado[2] &&
            Informe_estado[3].trackingDate
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[1].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <span
          *ngIf="
            !Informe_estado[1] &&
            !Informe_estado[2] &&
            Informe_estado[3] &&
            Informe_estado[3].trackingDate
          "
          style="font-size: 14px"
        >
          {{ Informe_estado[3].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
        <br />
        <span> <i class="fas fa-long-arrow-alt-down icon-down"></i> </span>
      </div>

      <div
        class="step col-12 text-center"
        [ngClass]="Informe_estado[3] ? 'step-active' : ''"
      >
        <span class="number mx-auto">
          <ng-container *ngIf="Informe_estado[3] === undefined"
            ><i class="fas fa-check"></i
          ></ng-container>
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status == 'N/A'
            "
            ><i class="fas fa-ban"></i
          ></ng-container>
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status != 'N/A'
            "
          >
            <i class="fas fa-check"></i
          ></ng-container>
        </span>
        <span class="subtitle">
          <ng-container *ngIf="Informe_estado[3] === undefined"
            >RECIBIDO</ng-container
          >
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status == 'N/A'
            "
            >Cancelada</ng-container
          >
          <ng-container
            *ngIf="
              Informe_estado[3] !== undefined &&
              Informe_estado[3].status != 'N/A'
            "
            >{{ Informe_estado[3].satusName }}</ng-container
          >
        </span>
        <br />
        <span
          *ngIf="Informe_estado[3] && Informe_estado[3].trackingDate"
          style="font-size: 14px"
        >
          {{ Informe_estado[3].trackingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
        </span>
      </div>
    </ng-container>
  </div>
</div>
